import type { WidgetDataContract } from "@nexus/widget-sdk";

/**
 * `protection-overview-event-cdn-gatekeeper` v1 — one protected event's CDN
 * Gatekeeper automated-response outcomes: the response mechanism used, how
 * often and how completely it fired, and, per detected pirate service, the
 * step at which the response actually disrupted the stream.
 */
export const CDN_GATEKEEPER_RESPONSES_CONTRACT: WidgetDataContract = {
  name: "protection-overview-event-cdn-gatekeeper",
  version: 1,
};

export interface CdnGatekeeperService {
  id: string;
  label: string;
  /**
   * Optional image reference per step (see `WidgetAssetsContext`): what the
   * pirate stream showed at that step. Without frames, steps are plain cells.
   */
  frames?: string[];
}

export interface CdnGatekeeperResponsesData {
  responseType: string;
  responseRate: number;
  responseCoverageRate: number;
  /** Step index (0-based) at which the response disrupts the stream. */
  triggerStepIndex: number;
  /** Number of time-step columns per pirate service row. */
  stepCount: number;
  services: CdnGatekeeperService[];
}
